<template>
  <div class="loginContainer">
    <el-form ref="form" :model="loginForm" :rules="loginRules">
      <el-form-item prop="userName">
        <el-input
          placeholder="请输入用户名"
          prefix-icon="el-icon-user-solid"
          v-model="loginForm.userName"
          class="userIcon"
        ></el-input>
      </el-form-item>
      <el-form-item prop="passWord">
        <el-input
          placeholder="请输入密码"
          v-model="loginForm.passWord"
          prefix-icon="el-icon-lock"
          :type="eyeFlag ? 'text' : 'password'"
          class="passwordIcon"
        >
          <i
            slot="suffix"
            class="font18"
            :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
            @click="eyeFlag = !eyeFlag"
          ></i>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="rememberPassword">
      <el-checkbox
        v-model="rememberPassword"
        @change="changeSelect"
        class="rememberTxt"
        >记住密码</el-checkbox
      >
      <!-- <el-link type="primary" @click="openResetPasswordDialog"
        >忘记密码</el-link
      > -->
    </div>
    <el-button
      :loading="showLoading"
      class="loginBtn"
      size="small"
      type="primary"
      @click="submit"
      >登录</el-button
    >
    <!-- 重置密码弹框 -->
    <resetpassword-dialog
      title="找回密码"
      width="50%"
      :visible.sync="dialogVisible"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      @closeDialog="closeDialog"
    >
      <el-form
        class="restForm"
        ref="restForm"
        :model="resetPasswordForm"
        :rules="resetPasswordRules"
        label-width="100px"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input
            placeholder="请输入"
            v-model="resetPasswordForm.mobile"
            id="mobile"
            ref="phoneNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="sms_code">
          <el-col :span="16">
            <el-input
              placeholder="请输入"
              v-model="resetPasswordForm.sms_code"
              id="sms_code"
            >
            </el-input>
          </el-col>
          <el-col :span="8" class="codeSpsn" v-if="!timingFlag">
            <el-link :underline="false" type="primary" @click="getSmsCode"
              >获取验证码</el-link
            >
          </el-col>
          <el-col :span="8" class="codeSpsn" v-else>
            <p class="count-down">{{ countDown }}</p>
          </el-col>
          <!-- <el-input
            placeholder="请输入"
            v-model="resetPasswordForm.sms_code"
            id="sms_code"
          >
          </el-input> -->
        </el-form-item>

        <el-form-item label="新密码" prop="password">
          <el-input
            placeholder="请输入"
            v-model="resetPasswordForm.password"
            id="password"
            type="password"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="repeatNewPassword">
          <el-input
            placeholder="请输入"
            v-model="resetPasswordForm.repeatNewPassword"
            id="repeatNewPassword"
            type="password"
            show-password
          >
          </el-input>
        </el-form-item>
      </el-form>
    </resetpassword-dialog>
  </div>
</template>

<script>
import { login } from '@/api/login'
import ResetpasswordDialog from '@/components/elementComponents/dialog/index.vue'
import resteForm from '@/components/elementComponents/form/index.vue'
export default {
  name: 'AccountPassword',
  components: { ResetpasswordDialog, resteForm },
  data () {
    return {
      eyeFlag: false,
      rememberPassword: false,
      loginForm: {
        userName: '',
        passWord: '',
        productId: '9c3b346a-d1f5-4463-bdec-4a55f5bccf4',
        scope: 'all',
        grant_type: 'password'
      },
      loginRules: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      showLoading: false,
      // 找回密码
      resetPasswordForm: {
        mobile: '',
        sms_code: '',
        password: '',
        repeatNewPassword: ''
      },
      resetPasswordRules: {
        mobile: [
          { required: true, message: '手机号必填', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        sms_code: [
          {
            required: true,
            message: '请填写验证码',
            trigger: 'blur'
          }
        ],
        password: [{ required: true, message: '必填', trigger: 'blur' }],
        repeatNewPassword: [
          {
            // required: true,
            // message: '必填',
            // trigger: 'blur'
            validator: this.validatePassword,
            trigger: 'blur'
          }
        ]
      },
      timingFlag: false,
      countDown: 60,
      timeId: null,
      dialogVisible: false
    }
  },
  // 页面加载时监听是否有记住密码
  beforeMount () {
    if (
      localStorage.getItem('loginInfo') != null &&
      Object.keys(localStorage.getItem('loginInfo')).length > 2
    ) {
      this.rememberPassword = true
      const loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
      // console.log('获取本地存储loginInfo', loginInfo)
      this.loginForm.userName = loginInfo.userName
      this.loginForm.passWord = loginInfo.passWord
    } else {
      this.rememberPassword = false
    }
  },
  mounted () {},
  watch: {
    timingFlag (newV) {
      if (newV) {
        console.log('this.timingFlag', this.timingFlag)
        console.log('需要打开定时器')
        this.openInterval()
      } else {
        console.log('需要关闭定时器')
        this.stopInterval()
        this.countDown = 60
      }
    }
  },
  methods: {
    openResetPasswordDialog () {
      this.dialogVisible = true
      console.log('忘记密码')
    },
    // 获取短信验证码
    getSmsCode () {
      // 表单验证通过才能获取
      // this.$refs.restForm.validateField('mobile', async errMsg => {
      //   if (errMsg) {
      //     console.log('手机号校验未通过')
      //   } else {
      //     console.log('校验通过')
      //     this.timingFlag = true
      //     const obj = {
      //       mobile: this.resetPasswordForm.mobile,
      //       sign: 'myek'
      //     }
      //     const res = await sendVerificationCode(obj)
      //     this.$message.success(res.message)
      //   }
      // })
    },
    openInterval () {
      this.timeId = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        } else {
          this.timingFlag = false
        }
      }, 1000)
    },
    stopInterval () {
      clearInterval(this.timeId)
    },

    validatePassword (rule, value, callback) {
      console.log('新', value)
      console.log('原', this.resetPasswordForm.password)
      if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
        console.log('密码验证一致通过')
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },

    handleConfirm () {
      // console.log('弹框确认按钮')
      // this.$refs.restForm.validate(async valid => {
      //   if (valid) {
      //     try {
      //       const res = await updatePassword(this.resetPasswordForm)
      //       this.$message.success(res.message)
      //     } catch (error) {
      //       this.$message.error(error)
      //     }
      //     this.dialogVisible = false
      //     this.resetForm('restForm')
      //   }
      // })
    },
    handleCancel () {
      this.dialogVisible = false
      console.log('弹框取消按钮')
      this.resetForm('restForm')
    },
    closeDialog () {
      this.dialogVisible = false
    },
    //
    async submit () {
      // 全局表单验证通过 调请求接口
      this.$refs.form.validate(async val => {
        if (val) {
          console.log('表单验证通过')
          this.showLoading = true
          const { userName, passWord } = this.loginForm
          const res = await login({ userName, passWord })
          if (res.code == 0) {
            sessionStorage.setItem('access_token', res.data)
            this.$message.success({ message: res.message, center: true })
            this.$router.push('/home')
            const loginInfo = {
              userName: this.loginForm.userName,
              passWord: this.loginForm.passWord
            }
            localStorage.setItem('userInfo', JSON.stringify(loginInfo))

            if (this.rememberPassword) {
              localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
            } else {
              // 不勾选记住密码，清除本地存储loginInfo
              if (localStorage.getItem('loginInfo')) {
                localStorage.removeItem('loginInfo')
              }
            }
          } else {
            this.$message.error({ message: res.message, center: true })
          }
          this.showLoading = false
        } else {
          console.log('表单验证失败')
          this.showLoading = false
        }

        // if (val) {
        //   console.log('表单验证通过')
        //   this.showLoading = true
        //   try {
        //     const res = await login(this.loginForm)
        //     // 接口状态码判断
        //     if (res.code === '0') {
        //       this.$message.success(res.message)
        //       // console.log('access_token', res.access_token)
        //       // 存储登录信息
        //       this.$store.commit('GET_LOGIN_INFO', res.data)
        //       sessionStorage.setItem('GET_LOGIN_INFO', res.data)
        //       // 存储access_token
        //       this.$store.commit('GET_ACCESS_TOKEN', res.access_token)
        //       sessionStorage.setItem('access_token', res.access_token)
        //       // 存储用户id
        //       this.$store.commit('GET_USERID', res.data.userId)
        //       sessionStorage.setItem('userId', res.data.userId)
        //       // 跳转路由
        //       this.$router.push('/')
        //       // 勾选记住密码
        //       if (this.rememberPassword) {
        //         const loginInfo = {
        //           userName: this.loginForm.userName,
        //           password: this.loginForm.password
        //         }
        //         // console.log('存储loginInfo', loginInfo)
        //         localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
        //       } else {
        //         // 不勾选记住密码，清除本地存储loginInfo
        //         if (localStorage.getItem('loginInfo')) {
        //           localStorage.removeItem('loginInfo')
        //         }
        //       }
        //     } else {
        //       this.showLoading = false
        //       this.$message.error(res.message)
        //     }
        //   } catch (error) {
        //     this.$message.error(error)
        //     this.showLoading = false
        //   }
        // } else {
        //   this.$message.error('请输入账号及密码')
        //   console.log('表单验证不通过')
        // }
      })
    },
    changeSelect () {
      console.log('选择', this.rememberPassword)
    }
  }
}
</script>

<style lang="less" scoped>
@media (min-width: 769px) and (max-width: 1364px) {
  html {
    font-size: 12px;
  }
  .rememberPassword {
    display: flex;
    justify-content: space-between;
    margin: 30px 0px !important;
  }
}
@media (max-width: 768px) {
  .rememberPassword {
    margin: 20px 20px !important;
  }
}
.loginContainer {
  margin: 30px 0;
}
.rememberPassword {
  display: flex;
  justify-content: space-between;
  margin: 60px 20px;
}
.rememberPassword .rememberTxt {
  color: hsla(0, 0%, 100%, 0.5);
}
.loginBtn {
  width: 100%;
  background-color: #5b83fb;
}
.loginBtn:hover {
  background-color: #5b83fb;
  font-size: 26px;
}
.el-input {
  margin-top: 10px;
  font-size: 18px;
}
::v-deep .el-input__inner {
  height: 47px;
  line-height: 47px;
}
::v-deep .el-button--small {
  font-size: 26px;
  letter-spacing: 10px;
}
.restForm {
  padding: 0 100px;
}
.restForm ::v-deep .el-input__inner {
  background-color: #0a1f5d;
  border: 2px solid #2c3f73;
  font-size: 16px;
}
.restForm ::v-deep .el-form-item__label {
  line-height: 57px;
}
.restForm ::v-deep .el-link--inner {
  line-height: 57px;
}
.codeSpsn {
  text-align: right;
}
.count-down {
  color: #1890ff;
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
  line-height: 57px;
}
.passwordIcon ::v-deep .el-input__suffix,
::v-deep .el-icon-lock {
  display: flex;
  align-items: center;
}
</style>

<style lang="less">
/* 恢复PC端的element样式 */
.el-message {
  font-size: 1em;
}
.el-message .el-message__content {
  font-size: 0.8em;
}
</style>
